import { render, staticRenderFns } from "./TaskAssignment.vue?vue&type=template&id=b2d3371c"
import script from "./TaskAssignment.vue?vue&type=script&lang=js"
export * from "./TaskAssignment.vue?vue&type=script&lang=js"
import style0 from "./TaskAssignment.vue?vue&type=style&index=0&id=b2d3371c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports